import { ActivatedRoute } from '@angular/router';

export function getUrlSegment(route: ActivatedRoute, children = false): string {
  return children ? route.firstChild?.snapshot.url[0]?.path : route.parent?.snapshot.url[0]?.path;
}
